/*
*###############################################################################
*Module Name                   : DPSearchBox.js                                #
*Purpose of the Module         : Search ModalUI                                #
*Description of the Module     : Common Search Modal Component with Table      #
*Original Author               :  T A C Priyashad                              #
*Date                          : Sunday, August 22nd 2021, 7:35:18 am          #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Row, Col, Card, CardBody, CardTitle, Button, Modal } from "reactstrap"
import DPSwitch from "./DPSwitch";

const DPStockFreezePopUp = (props) => {

    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [searchBy, setSearchBy] = useState("GP_CODE")

    useEffect(() => {
        setPage(1)
        setSearch("")
        setSearchBy("GP_CODE")
    }, [props.isOpen])


    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };



    const newDataTable = props.data.filter((value) => {
        if (searchBy != "GP_CODE") {
            return value[searchBy].toLowerCase().includes(search.toLowerCase())
        } else {
            return value[searchBy].toLowerCase().includes(search.toLowerCase())
        }
    })

    const indexOfLastPost = page * 10
    const indexOfFirstPost = indexOfLastPost - 10
    const currentDetailRows = newDataTable.slice(indexOfFirstPost, indexOfLastPost)

    function handleHeaderSwitchChange(e) {
        if (e) {
            props.setCode(props.data.map(x => x.GP_CODE))
        } else {
            props.setCode([])
        }
    }

    return (
        <div>
            <Modal
                size="xl"
                isOpen={props.isOpen}
                toggle={props.toggle}
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {props.mainTitle}
                    </h5>
                    <button
                        onClick={props.toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row className="mb-1">
                        <Col mb={12} sm={3}>
                            <input type="text" className="form-control" placeholder={"Search by " + (searchBy == "GP_CODE" ? "Code" : "Description")} onChange={(e) => {
                                setSearch(e.target.value)
                                setPage(1)
                            }} />
                        </Col>

                    </Row>
                    <Row>
                        <Col className="col-12">
                            <table className="table table-sm table-bordered table-hover">
                                <thead className="table-light" >
                                    <tr>
                                        <th style={{ width: "50px" }}>#</th>
                                        <th style={{ width: "150px", cursor: 'pointer' }} title={"Code"} onClick={() => {
                                            setSearchBy("GP_CODE")
                                        }}>Code</th>
                                        <th style={{ width: "400px", cursor: 'pointer' }} title={"Description"} onClick={() => {
                                            setSearchBy("GP_DESC")
                                        }}>Description</th>
                                        <th> <DPSwitch
                                            checked={props.code.length == props.data.length ? true : false}
                                            onChange={(e) => {
                                                handleHeaderSwitchChange(e)
                                            }}
                                        />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentDetailRows.map((item, index) => {

                                        function switchOnClick(e) {

                                            if (e) {
                                                if (props.code.find(x => x === item.GP_CODE) == undefined) {
                                                    var newCodes = [...props.code];
                                                    newCodes.push(item.GP_CODE);
                                                    props.setCode(newCodes);
                                                }
                                            } else {
                                                var newCodes = props.code.filter(x => x !== item.GP_CODE);
                                                props.setCode(newCodes);
                                            }

                                        }

                                        return (
                                            <tr key={index}>
                                                <td>{indexOfFirstPost + index + 1}</td>
                                                <td>{item.GP_CODE}</td>
                                                <td>{item.GP_DESC}</td>
                                                <td> <DPSwitch
                                                    checked={props.code.find(x => x === item.GP_CODE) != undefined ? true : false}
                                                    onChange={(e) => {
                                                        switchOnClick(e)
                                                    }}
                                                /></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} md={12} className="mb-12-sm">
                            <ReactPaginate
                                previousLabel={'Previous'}
                                nextLabel={'Next'}
                                breakLabel={'...'}
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                pageCount={Math.ceil(newDataTable.length / 10)}
                                pageRangeDisplayed={2}
                                onPageChange={handlePageClick}
                                forcePage={page - 1}
                                renderOnZeroPageCount={null}
                                activeClassName={'active'}
                                activeLinkClassName={'page-link'}
                                containerClassName={'pagination justify-content-end pagination-sm'}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>

        </div>
    );
}

export default DPStockFreezePopUp;